import type { RouteObject } from 'react-router';
import BackgroundLayout from '@layouts/BackgroundLayout/BackgroundLayout';
import IndexLayout from '@layouts/IndexLayout/IndexLayout';
import AddAssignmentPage from '@pages/addAssignment/AddAssignmentPage';
import AddUserPage from '@pages/addUser/AddUserPage';
import AppsPage from '@pages/apps/AppsPage';
import HomePage from '@pages/home/HomePage';
import UsersPage from '@pages/users/UsersPage';

const appRoutes: RouteObject[] = [
	{
		path: '/',
		Component: IndexLayout,
		children: [
			{
				Component: BackgroundLayout,
				children: [
					{ index: true, Component: HomePage },
					// Reached from the Apps page, not the sidebar. Ranked above
					// apps/:tab because a static segment beats a dynamic one.
					{ path: 'apps/assign', Component: AddAssignmentPage },
					// Apps is tabbed, and the tab is a segment of its own. Bare
					// /apps carries no tab, so the page redirects to its default.
					{ path: 'apps', Component: AppsPage },
					{ path: 'apps/:tab', Component: AppsPage },
					{ path: 'users', Component: UsersPage },
					// Reached from the Users page, not the sidebar.
					{ path: 'users/assign', Component: AddUserPage },
				],
			},
		],
	},
];

export default appRoutes;
